const transformDate = (date = '') => {
  let offset = new Date().getTimezoneOffset() / 60;

  if (offset < 10) {
    offset = '0' + offset;
  }

  if (date.search('T') == -1) {
    date += `T00:00:00-${offset}:00`;
  }

  const _date = new Date(date);
  const month = _date.getMonth() + 1;
  const day = _date.getDate();
  const year = _date.getFullYear();
  return (month > 9 ? '' : '0') + month + '/' + (day > 9 ? '' : '0') + day + '/' + year;
};

function defaultTodayString() {
  const today = new Date();
  return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
    today.getDate(),
  ).padStart(2, '0')}`;
}

export { transformDate, defaultTodayString };
